/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.business.units.rpc.BusinessUnitsDisplaysService
 */

export const getBusinessUnitDisplaysForUserRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsDisplaysService',
  rpcName: 'getBusinessUnitDisplaysForUser',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADMaJU4WVA0tC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBusinessUnitDisplaysForUserByNamesRpc = {
  serviceName: 'com.hubspot.business.units.rpc.BusinessUnitsDisplaysService',
  rpcName: 'getBusinessUnitDisplaysForUserByNames',
  auth: 'app',
  fingerprint: 'YdRnXCf4OILMaJU4WVA0tC8zu6odjm0u',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};